module.exports = __webpack_public_path__ + "img/doc-Icon.63a136d3.svg";